import { ItemPedido } from './pedido';
import { Selecao } from './selecao';

export class Fileira {
  id: number;
  cupom: string;
  fileiras: number;
  numPaineis: number;
  orientacao: string;
  telhado: number;
  telhadoDescricao: string;
  opcaoOrientacao: Selecao;
  opcaoTelhado: Selecao;
  larguraPainel: number;
  alturaPainel: number;
  fornecedor: number;
  fornecedorDescricao: string;
  valorTotal: number;
  itens: ItemPedido[];
  idFornecedorPainel: number;
  comprimentoPainel: number;
  microInversor: boolean;
  referenciaPainel: string;
  idFornecedorEstrutura?: number;
  qtdFileiras?: number;
  logo$: any;
  qtdTotalModulosTodosLayouts: number;
  idPainel: number;
  codErpPainel: number;
  potenciaTotal: number;
  buscouImagem: boolean;
  idDistribuidor?: number;
  uf: string;
  tipoInversor: number;
}
